module.exports = __webpack_public_path__ + "static/media/snowy-5.3def7c9f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weather-icons/snowy-5.svg
// module id = 530
// module chunks = 0